import { common as frCommon } from './fr/common';
import { services as frServices } from './fr/services';
import { about as frAbout } from './fr/about';
import { projects as frProjects } from './fr/projects';
import { quote as frQuote } from './fr/quote';
import { legal as frLegal } from './fr/legal';

import { common as arCommon } from './ar/common';
import { services as arServices } from './ar/services';
import { about as arAbout } from './ar/about';
import { projects as arProjects } from './ar/projects';
import { quote as arQuote } from './ar/quote';
import { legal as arLegal } from './ar/legal';

import { common as nlCommon } from './nl/common';
import { services as nlServices } from './nl/services';
import { about as nlAbout } from './nl/about';
import { projects as nlProjects } from './nl/projects';
import { quote as nlQuote } from './nl/quote';
import { legal as nlLegal } from './nl/legal';

export const resources = {
  fr: {
    common: frCommon,
    services: frServices,
    about: frAbout,
    projects: frProjects,
    quote: frQuote,
    legal: frLegal
  },
  ar: {
    common: arCommon,
    services: arServices,
    about: arAbout,
    projects: arProjects,
    quote: arQuote,
    legal: arLegal
  },
  nl: {
    common: nlCommon,
    services: nlServices,
    about: nlAbout,
    projects: nlProjects,
    quote: nlQuote,
    legal: nlLegal
  }
};